import { render, staticRenderFns } from "./liaison.vue?vue&type=template&id=6a8625c5&scoped=true&"
import script from "./liaison.vue?vue&type=script&lang=js&"
export * from "./liaison.vue?vue&type=script&lang=js&"
import style0 from "./liaison.vue?vue&type=style&index=0&id=6a8625c5&scoped=true&lang=css&"
import style1 from "./liaison.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8625c5",
  null
  
)

export default component.exports